(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('eimageCaptcha', eimageCaptcha);

    function eimageCaptcha() {
        var directive = {
            templateUrl: '/app/common/eimage-captcha.html',
            scope: {
                captchaKey: '=',
                captchaValue: '=',
                onChange: '&',
                remainingAttempts: '='
            },
            restrict: 'EA',
            controller: eimageCaptchaController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    eimageCaptchaController.$inject = ['captcha_factory', '$scope', '$interval'];
    function eimageCaptchaController(captcha_factory, $scope, $interval) {
        var vm = this;
        vm.captchaImage = null;
        vm.userInput = '';
        vm.loading = false;
        vm.errorMessage = null;
        vm.expiresInSeconds = 0;
        var countdownInterval = null;
        var CAPTCHA_MIN_LENGTH = 5;

        vm.$onInit = function () {
            fetchCaptcha();
        };

        vm.fetchCaptcha = fetchCaptcha;
        vm.refreshCaptcha = refreshCaptcha;
        vm.formatTime = formatTime;

        vm.handleChange = function () {
            vm.remainingAttempts = null;
            if (vm.userInput && vm.userInput.length >= CAPTCHA_MIN_LENGTH) {
                vm.captchaValue = vm.userInput;
            } else {
                vm.captchaValue = null;
            }
            if (vm.onChange) vm.onChange({ value: vm.captchaValue });
        };


        function fetchCaptcha() {
            vm.loading = true;
            vm.errorMessage = null;
            vm.userInput = '';
            vm.captchaValue = null;
            if (vm.onChange) vm.onChange({ value: null });
            vm.captchaKey = null;
            vm.captchaImage = null;

            captcha_factory.getCaptcha().$promise.then(function (resp) {
                vm.loading = false;
                vm.captchaImage = resp.captchaImageBase64;
                vm.captchaKey = resp.captchaKey;
                vm.expiresInSeconds = resp.expiresInSeconds || 120;
                startCountdown();
            }, function (err) {
                vm.loading = false;
                vm.captchaImage = null;
                vm.errorMessage = 'eimage_captcha_load_error';
            });
        }

        function refreshCaptcha() {
            stopCountdown();
            fetchCaptcha();
        }

        function startCountdown() {
            stopCountdown();
            countdownInterval = $interval(function () {
                if (vm.expiresInSeconds > 0) {
                    vm.expiresInSeconds--;
                } else {
                    stopCountdown();
                    fetchCaptcha();
                }
            }, 1000);
        }

        function stopCountdown() {
            if (countdownInterval) {
                $interval.cancel(countdownInterval);
                countdownInterval = null;
            }
        }

        function formatTime() {
            var minutes = Math.floor(vm.expiresInSeconds / 60);
            var seconds = vm.expiresInSeconds % 60;
            return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        }

        // Cleanup on destroy
        $scope.$on('$destroy', function () {
            stopCountdown();
        });
    }
})();
